/** Figma arc path (State=1, 20×20) — internal; fill inherits `color` from the recipe root. */
const SPINNER_ARC_PATH =
  'M19.1155 10C19.604 10 20.0041 10.3968 19.9609 10.8834C19.8034 12.6594 19.1732 14.3668 18.1285 15.8248C16.9114 17.5232 15.1929 18.7977 13.2144 19.4693C11.2358 20.1409 9.09662 20.1759 7.09716 19.5694C5.09769 18.9629 3.33844 17.7453 2.06647 16.0876C0.794502 14.43 0.0737208 12.4155 0.00535636 10.3272C-0.0630081 8.23888 0.524478 6.1816 1.68531 4.4443C2.84613 2.707 4.52199 1.37695 6.4775 0.640943C8.15619 0.00912864 9.96857 -0.157674 11.7248 0.149861C12.206 0.23412 12.4857 0.723251 12.3593 1.1951V1.1951C12.2328 1.66695 11.748 1.94191 11.2653 1.86682C9.86819 1.64945 8.43323 1.79499 7.10063 2.29655C5.49104 2.90235 4.11164 3.99712 3.15617 5.4271C2.20069 6.85707 1.71713 8.55042 1.7734 10.2693C1.82967 11.9882 2.42294 13.6463 3.4699 15.0107C4.51686 16.3751 5.9649 17.3774 7.61067 17.8766C9.25643 18.3758 11.0172 18.347 12.6458 17.7942C14.2743 17.2414 15.6888 16.1923 16.6906 14.7944C17.5199 13.637 18.0319 12.2886 18.1835 10.8828C18.2359 10.3972 18.627 10 19.1155 10V10Z';

export const SpinnerArc = () => (
  <svg
    viewBox="0 0 19.9641 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-testid="spinner-arc"
  >
    <path d={SPINNER_ARC_PATH} fill="currentColor" />
  </svg>
);
